module.exports = __webpack_public_path__ + "media/images/flags/4x3/rwa-b876f6d9250761e91f6f24e99033c6f0.svg";